import { clone } from 'lodash-es'
import noop from 'lodash-es/noop'
import { createContext } from 'react'

import { useGeoFences } from '@/feature/observatory'
import { GeoFence, GeofenceCreateUpdatePayload } from '@/feature/observatory/types/GeoFence.types'
import { GeoFenceEvents } from '@/feature/observatory/types/GeoFenceEvent.types'

import { defaultFallback } from '@/lib/core/hooks/usePaginatedNetworkResource'

import { useAllAssets } from '@/lib/features/Assets/api'

type ObservatoryContextValue = {
  assets: ReturnType<typeof useAllAssets>
  geoFences: ReturnType<typeof useGeoFences>

  createGeoFence: (geoFence: GeofenceCreateUpdatePayload) => Promise<unknown>
  editGeoFence: (
    geoFenceId: GeoFence['id'],
    geoFence: GeofenceCreateUpdatePayload,
  ) => Promise<unknown>
  deleteGeoFence: (geoFenceId: GeoFence['id']) => Promise<unknown>

  unlockMap: () => void

  geoFenceEvents: GeoFenceEvents
}

const asyncNoop = async () => {
  throw new Error('Not implemented')
}

export const ObservatoryContext = createContext<ObservatoryContextValue>({
  assets: {
    isLoading: true,
    data: clone(defaultFallback),
    isValidating: true,
    error: undefined,
    mutate: () => Promise.resolve(undefined),
    page: 1,
    pageSize: -1,
    setPage: noop,
    setPageSize: noop,
    setSortingInfo: noop,
    sortingInfo: {},
  },
  unlockMap: noop,
  geoFences: {
    isLoading: true,
    data: clone(defaultFallback),
    isValidating: true,
    error: undefined,
    mutate: () => Promise.resolve(undefined),
    page: 1,
    pageSize: -1,
    setPage: noop,
    setPageSize: noop,
    setSortingInfo: noop,
    sortingInfo: {},
  },
  geoFenceEvents: {},

  createGeoFence: asyncNoop,
  editGeoFence: asyncNoop,
  deleteGeoFence: asyncNoop,
})
